import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { AuthState, AuthStore, RemoteConfigStore } from '@store';

@Injectable()
export class ProPlusFeaturesGuardService {
  constructor(
    private authStore: AuthStore,
    private remoteConfigStore: RemoteConfigStore,
    private router: Router
  ) {}

  canActivateChild(): Observable<boolean> {
    return this.checkAuth();
  }

  canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    const hasAccessToProPlusFeaturesByRemoteConfig$ = this.remoteConfigStore.hasAccessToProPlusFeaturesByCompanyId$.pipe(
      mergeMap((hasAccessByCompanyId) =>
        iif(
          () => hasAccessByCompanyId,
          of(true),
          this.remoteConfigStore.hasAccessToProPlusFeaturesByVkOrg$
        )
      )
    );

    const hasAccess$ = this.authStore.isEndUser$.pipe(
      mergeMap((isEndUser) =>
        iif(() => isEndUser, of(false), hasAccessToProPlusFeaturesByRemoteConfig$)
      )
    );

    return this.authStore.state$.pipe(
      filter((state: AuthState) => {
        if (!state.authorized && !state.authorizing && !state.authenticating) {
          this.router.navigate(['/home']);
        }

        return state.authorized;
      }),
      mergeMap((state) => iif(() => state.demo, of(true), hasAccess$))
    );
  }
}
